import script from "./MailForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MailForm.vue?vue&type=script&setup=true&lang=js"

import "./MailForm.vue?vue&type=style&index=0&id=f81e4822&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f81e4822"]])

export default __exports__